














































import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import DateSliderItem from '@/views/TimeEntries/Components/DateSliderItem.vue';
import { TimeEntryDay } from '@/services/api/nswag/stapiclient_generated';
import { DateTime } from 'luxon';
import {dateEqual, startOfWeek, endOfWeek, DateForEach} from '@/utlitities/helper';
import {UserStore} from '@/store/user-module';

@Component({
  components: {
    DateSliderItem,
  },
})
export default class DateSlider extends Vue {
  @Prop() days!: TimeEntryDay[];
  @Prop() value!: DateTime;
  @Prop() loading!: boolean;

  get selectedDate() {
    return this.value ?? UserStore.userNowDateTime;
  }

  get dtDays(){
    let startOfWeekDt = startOfWeek(this.selectedDate);
    let endOfWeekDt = endOfWeek(this.selectedDate);

    return DateForEach(startOfWeekDt, endOfWeekDt);
  }

  getTimeEntryDay(day: DateTime){
    return this.days.find(x=>dateEqual(DateTime.fromISO(x.entryDay ?? ''), day)) ?? TimeEntryDay.fromJS({entryDay: day});
  }

  @Emit('input')
  moveWeek(weekOffset: number) {
    return this.selectedDate.plus({ weeks: weekOffset });
  }

  @Emit('input')
  moveDay(dayOffset: number) {
    return this.selectedDate.plus({ days: dayOffset });
  }

  @Emit('input')
  changeDay(date: DateTime) {
    return date;
  }

  @Emit('input')
  changeDayIso(dateIso: string) {
    return DateTime.fromISO(dateIso);
  }

  @Emit('input')
  goToToday() {
    return UserStore.userNowDateTime;
  }

  isSelectedDate(entryDay: DateTime) {
    return dateEqual(this.selectedDate, entryDay);
  }
}
